module.exports = __webpack_public_path__ + "media/images/logo-3-210d28f1144c0d31af22bfdc82ffb0b1.png";